function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var proGalleryItemsToOrganizeMediaItems = function proGalleryItemsToOrganizeMediaItems(proGalleryItems) {
  try {
    return proGalleryItems.map(proGalleryItemToOrganizeMediaItem);
  } catch (e) {
    console.error('Wrong format for pro gallery items', proGalleryItems, e);
    return [];
  }
};
export var organizeMediaItemsToProGalleryItems = function organizeMediaItemsToProGalleryItems(organizeMediaItems) {
  try {
    return organizeMediaItems.map(organizeMediaItemToProGalleryItem);
  } catch (e) {
    console.error('Wrong format for pro gallery items', organizeMediaItems, e);
    return [];
  }
};

var proGalleryItemToOrganizeMediaItem = function proGalleryItemToOrganizeMediaItem(proGalleryItem) {
  var commonRootFields = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    id: proGalleryItem.itemId,
    mediaUrl: proGalleryItem.mediaUrl,
    orderIndex: proGalleryItem.orderIndex,
    name: proGalleryItem.metaData.name
  }, 'title' in proGalleryItem.metaData && {
    title: proGalleryItem.metaData.title
  }), 'description' in proGalleryItem.metaData && {
    description: proGalleryItem.metaData.description
  }), {}, {
    link: proGalleryToOrganizeMediaLink(proGalleryItem.metaData.link)
  }, 'secure' in proGalleryItem && {
    secure: proGalleryItem.secure
  }), {}, {
    metaData: proGalleryItem.metaData
  });

  if (proGalleryItem.metaData.type && proGalleryItem.metaData.type === 'video') {
    var posters = [].concat(proGalleryItem.metaData.posters);

    if (proGalleryItem.metaData.customPoster) {
      posters.unshift(proGalleryItem.metaData.customPoster);
    }

    posters[0] = _objectSpread(_objectSpread({}, posters[0]), 'focalPoint' in proGalleryItem.metaData && {
      focalPoint: proGalleryToOrganizeMediaFocalPoint(proGalleryItem.metaData.focalPoint)
    });
    return _objectSpread(_objectSpread({}, commonRootFields), {
      dataType: 'Video',
      videoMetadata: {
        posters: posters,
        duration: proGalleryItem.metaData.duration,
        height: proGalleryItem.metaData.height,
        width: proGalleryItem.metaData.width,
        isExternal: proGalleryItem.metaData.isExternal,
        hasCustomPoster: !!proGalleryItem.metaData.customPoster
      }
    });
  } else if (proGalleryItem.metaData.type && proGalleryItem.metaData.type === 'text') {
    return _objectSpread(_objectSpread({}, commonRootFields), {
      dataType: 'Text',
      textMetadata: {
        width: proGalleryItem.metaData.width,
        height: proGalleryItem.metaData.height,
        html: proGalleryItem.metaData.html,
        textStyle: proGalleryItem.metaData.textStyle,
        editorHtml: proGalleryItem.metaData.editorHtml,
        fontPickerStyleParamName: proGalleryItem.metaData.fontPickerStyleParamName
      }
    });
  } else {
    // photo
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, commonRootFields), 'imageToken' in proGalleryItem && {
      imageToken: proGalleryItem.imageToken
    }), 'token' in proGalleryItem && {
      token: proGalleryItem.token
    }), {
      dataType: 'Photo',
      photoMetadata: _objectSpread(_objectSpread({
        height: proGalleryItem.metaData.height,
        width: proGalleryItem.metaData.width
      }, 'focalPoint' in proGalleryItem.metaData && {
        focalPoint: proGalleryToOrganizeMediaFocalPoint(proGalleryItem.metaData.focalPoint)
      }), 'sharpParams' in proGalleryItem.metaData && {
        sharpParams: proGalleryItem.metaData.sharpParams
      })
    });
  }
};

var organizeMediaItemToProGalleryItem = function organizeMediaItemToProGalleryItem(organizeMediaItem) {
  var commonRootFields = _objectSpread({
    itemId: organizeMediaItem.id,
    orderIndex: organizeMediaItem.orderIndex,
    mediaUrl: organizeMediaItem.mediaUrl
  }, 'secure' in organizeMediaItem && {
    secure: organizeMediaItem.secure
  });

  var commonMetaDataFields = _objectSpread(_objectSpread({}, organizeMediaItem.metaData), _objectSpread(_objectSpread(_objectSpread({}, 'title' in organizeMediaItem && {
    title: organizeMediaItem.title
  }), 'description' in organizeMediaItem && {
    description: organizeMediaItem.description
  }), {}, {
    name: organizeMediaItem.name,
    link: organizeMediaToProGalleryLink(organizeMediaItem.link)
  }));

  if (organizeMediaItem.dataType === 'Video') {
    var focalPoint = organizeMediaItem.videoMetadata.posters[0].focalPoint ? organizeMediaToProGalleryFocalPoint(organizeMediaItem.videoMetadata.posters[0].focalPoint) : null;
    var customPoster;
    var posters = [].concat(organizeMediaItem.videoMetadata.posters);

    if (organizeMediaItem.videoMetadata.hasCustomPoster) {
      customPoster = organizeMediaItem.videoMetadata.posters[0];

      if (customPoster.focalPoint) {
        delete customPoster.focalPoint;
      }

      posters.shift();
    } else {
      customPoster = '';
    }

    return _objectSpread(_objectSpread({}, commonRootFields), {
      metaData: _objectSpread(_objectSpread({}, commonMetaDataFields), _objectSpread({
        type: 'video',
        customPoster: customPoster,
        posters: posters,
        duration: organizeMediaItem.videoMetadata.duration,
        height: organizeMediaItem.videoMetadata.height,
        width: organizeMediaItem.videoMetadata.width
      }, focalPoint && {
        focalPoint: focalPoint
      }))
    });
  } else if (organizeMediaItem.dataType === 'Text') {
    return _objectSpread(_objectSpread({}, commonRootFields), {
      metaData: _objectSpread(_objectSpread({}, commonMetaDataFields), {
        type: 'text',
        width: organizeMediaItem.textMetadata.width,
        height: organizeMediaItem.textMetadata.height,
        html: organizeMediaItem.textMetadata.html,
        textStyle: organizeMediaItem.textMetadata.textStyle,
        editorHtml: organizeMediaItem.textMetadata.editorHtml,
        fontPickerStyleParamName: organizeMediaItem.textMetadata.fontPickerStyleParamName
      })
    });
  } else {
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, commonRootFields), 'imageToken' in organizeMediaItem && {
      imageToken: organizeMediaItem.imageToken
    }), 'token' in organizeMediaItem && {
      token: organizeMediaItem.token
    }), {
      metaData: _objectSpread(_objectSpread({}, commonMetaDataFields), _objectSpread(_objectSpread({
        height: organizeMediaItem.photoMetadata.height,
        width: organizeMediaItem.photoMetadata.width
      }, 'focalPoint' in organizeMediaItem.photoMetadata && {
        focalPoint: organizeMediaToProGalleryFocalPoint(organizeMediaItem.photoMetadata.focalPoint)
      }), 'sharpParams' in organizeMediaItem.photoMetadata && {
        sharpParams: organizeMediaItem.photoMetadata.sharpParams
      }))
    });
  }
};

var proGalleryToOrganizeMediaFocalPoint = function proGalleryToOrganizeMediaFocalPoint(focalPoint) {
  return {
    x: focalPoint ? focalPoint[0] : 0.5,
    y: focalPoint ? focalPoint[1] : 0.5
  };
};

export var organizeMediaToProGalleryFocalPoint = function organizeMediaToProGalleryFocalPoint(focalPoint) {
  return focalPoint ? [focalPoint.x, focalPoint.y] : [0.5, 0.5];
};

var proGalleryToOrganizeMediaLink = function proGalleryToOrganizeMediaLink(link) {
  if (link) {
    if (link.data && link.data.type === 'PageLink') {
      // add the page name if the link is a page
      link.data.pageName = window.sitePages && window.sitePages.pagesNamesByIds && window.sitePages.pagesNamesByIds[link.data.pageId.replace(/\W/g, '')] || '';
    }

    return _objectSpread(_objectSpread({}, link), {}, {
      text: link.text ? link.text : defaultLinkText(link),
      // NEW:
      hasLink: checkLink(link),
      value: defaultLinkValue(link)
    });
  } else {
    return {
      hasLink: false
    };
  }
};

var organizeMediaToProGalleryLink = function organizeMediaToProGalleryLink(link) {
  var hasLink = link.hasLink,
      value = link.value,
      text = link.text,
      data = link.data,
      pgLinkFields = _objectWithoutPropertiesLoose(link, ["hasLink", "value", "text", "data"]); // hasLink and value are organize media internal fields (were created for OM)


  if (data) {
    var pageName = data.pageName,
        pgLinkDataField = _objectWithoutPropertiesLoose(data, ["pageName"]);

    pgLinkFields.data = pgLinkDataField;
  }

  if (text) {
    pgLinkFields.text = text;
  }

  return pgLinkFields;
};

export var checkLink = function checkLink(link) {
  if (link.type === 'wix') {
    return !!link.data.type;
  }

  return !!link.url;
};
export var defaultLinkText = function defaultLinkText(link) {
  switch (link.type) {
    case 'wix':
      var linkData = link.data;

      if (linkData) {
        switch (linkData.type) {
          case 'PageLink':
            return "Go to Page " + linkData.pageName;

          case 'AnchorLink':
            return "Scroll to " + linkData.anchorName;

          case 'ExternalLink':
            return "" + linkData.url;

          case 'EmailLink':
            return "Email " + linkData.recipient;

          case 'PhoneLink':
            return "Call " + linkData.phoneNumber;

          case 'DocumentLink':
            return "Open " + linkData.name;

          default:
            return 'Go to Link';
        }
      } else {
        return 'Go to Link';
      }

    case 'web':
      return linkTitleFromUrl(link.url) || link.url;

    case 'page':
      return link.title;

    default:
      return '';
  }
};
export var defaultLinkValue = function defaultLinkValue(link) {
  var linkData = link.data;

  switch (link.type) {
    case 'wix':
      if (linkData) {
        switch (linkData.type) {
          case 'PageLink':
            if (linkData.pageName) {
              return "PAGE - " + linkData.pageName;
            } else {
              return 'PAGE';
            }

          case 'AnchorLink':
            return "ANCHOR - " + linkData.anchorName;

          case 'ExternalLink':
            return "LINK - " + linkData.url;

          case 'EmailLink':
            return "EMAIL - " + linkData.recipient;

          case 'PhoneLink':
            return "PHONE - " + linkData.phoneNumber;

          case 'DocumentLink':
            return "DOCUMENT - " + linkData.name;

          default:
            return 'Add a Link';
        }
      } else {
        return 'Add a Link';
      }

    case 'web':
      return link.url;

    case 'page':
      return link.title;

    default:
      return '';
  }
};

var linkTitleFromUrl = function linkTitleFromUrl(linkUrl) {
  var regex = /[^/]*\.\w+$/g;
  var regexRes = regex.exec(linkUrl);
  var match = regexRes && regexRes[0];
  return match && match.split('.')[0];
};